export default "__VITE_ASSET__f00d43dd__"